// Vendor
import { defineStore } from 'pinia';
import { RouteEnum } from 'src/shared/enum/route.enum';
import {
  _setActiveRoute,
  _addOpenedModal,
  _removeOpenedModal,
  _clearOpenedModal,
  _getLastInserted,
} from './actions';

// Personal libs
import { IStoreRouterState } from './router.interface';
import RouterState from './state';

export const useRouterStore = defineStore('router', {
  state: (): IStoreRouterState => ({ ...RouterState }),
  actions: {
    setActiveRoute(route?: RouteEnum) {
      return _setActiveRoute(this, route);
    },
    addOpenedModal(uuid: string) {
      return _addOpenedModal(this, uuid);
    },
    removeOpenedModal(uuid: string) {
      return _removeOpenedModal(this, uuid);
    },
    clearOpenedModal() {
      return _clearOpenedModal(this);
    },
    getLastInserted() {
      return _getLastInserted(this);
    },
  },
});
